import React from 'react';
import { useSelector } from 'react-redux';
import UserEditablePopup from '../userEditablePopup/UserEditablePopup';

const UserSearchBar = ({ auths, setTableData, userCounts }) => {
  const idLimitedCount = useSelector((store) => store.settings.setting.idLimitedCount); // 장치 데이터
  const userInit = {
    userIdx: null,
    userId: '',
    userPw: '',
    userNm: '',
    authIdx: 1,
  };

  if (userCounts >= idLimitedCount) {
    return null;
  }

  return (
    <div className="searchBar-conatiner">
      <div className="form-row">
        <UserEditablePopup user={userInit} dataReloadFunc={setTableData} auths={auths}>
          <div className="search-condition col-xl-1 col-sm-6">
            <button className="table-search-submit btn btn-info">등록</button>
          </div>
        </UserEditablePopup>
      </div>
    </div>
  );
};

export default UserSearchBar;
